import { createContext, useState } from 'react';

import OmeMeetOrgUnitEntryInfoData from './OmeMeetOrgUnitEntryInfoData';

export const OmeMeetOrgUnitEntryInfoStateContext = createContext();

const OmeMeetOrgUnitEntryInfoContextProvider = ({ children }) => {
  const stateHook = useState(OmeMeetOrgUnitEntryInfoData.INITIAL_STATE);

  return (
    <OmeMeetOrgUnitEntryInfoStateContext.Provider value={stateHook}>
      {children}
    </OmeMeetOrgUnitEntryInfoStateContext.Provider>
  );
};

export default OmeMeetOrgUnitEntryInfoContextProvider;